import React from "react";

// // // //

/**
 * OpenSearchDescription
 * Add OpenSearch link to the <head> of the HTML document.
 * This enables browsers to detect the site as searchable and allows users
 * to add RWA.xyz to their browser's search engine list.
 */
export function OpenSearchDescription() {
    return (
        <link
            type="application/opensearchdescription+xml"
            rel="search"
            href="/OpenSearchDescription.xml"
        />
    );
}
